class ReadMore {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;

        self.element = self.elem.querySelector('[data-read-more-element]');
        self.elementContent = self.elem.querySelector('[data-read-more-element-content]');
        self.trigger = self.elem.querySelector('[data-read-more-trigger]');
        self.triggerText = self.elem.querySelector('[data-read-more-trigger-text]');
    }

    init() {
        let self = this;

        self.readMoreToggle();
    };

    readMoreToggle() {
        let self = this;

        self.element.style.maxHeight = 0;

        self.trigger.addEventListener('click', (e) => {
            if (self.element.classList.contains('is-active')) {
                self.element.classList.remove('is-active');
                self.element.style.maxHeight = 0;
                self.trigger.classList.remove('is-active');
                self.triggerText.innerText = 'Read more';
            } else {
                self.element.classList.add('is-active');
                self.element.style.maxHeight = self.elementContent.offsetHeight+'px';
                self.trigger.classList.add('is-active');
                self.triggerText.innerText = 'Read less';
            }
        });
    }
}

export default ReadMore;
